import { gql } from '@apollo/client'

import { FRAGMENT_IMAGE, FRAGMENT_PERSON_INFO } from '../../../queries'
import { isPreview } from '../../../services/contenful'

export const FRAGMENT_EVENT = gql`
  fragment EventInfo on Event {
    authorSlug
    eventId
    host {
      ...PersonInfo
    }
    listImage {
      ...Image
    }
    featuredImage {
      ...Image
    }
    image {
      ...Image
    }
    illustration {
      ...Image
    }
    callout {
      json
    }
    excerpt
    book {
      title
      bookCover
      authorSlug
    }
    theme
    primaryColor
    secondaryColor
    rsvpButtonColor
    ticketPrice
    listTitle
    slug
    title
    date
    rsvpLink
    joinLink
    type
    featured
    appleCalendarLink
    googleCalendarLink
    outlookCalendarLink
    sys {
      id
    }
    seoTitle
    seoDescription
  }
  ${FRAGMENT_IMAGE}
  ${FRAGMENT_PERSON_INFO}
`

export const GET_ALL_EVENTS = gql`
  query Events {
    eventCollection(order: date_DESC, preview: ${isPreview}) {
      items {
        ...EventInfo
      }
    }
  }
  ${FRAGMENT_EVENT}
`

export const GET_EVENT = gql`
  query Event($slug: String!) {
    eventCollection(where: { slug: $slug }, preview: ${isPreview}) {
      items {
        info {
          json
        }
        video
        participantsCollection(limit: 10) {
          items {
            ...PersonInfo
          }
        }
        suggestedClubs {
          sys {
            id
          }
        }
        ...EventInfo
      }
    }
  }
  ${FRAGMENT_EVENT}
  ${FRAGMENT_PERSON_INFO}
`

export const GET_EVENT_LIST = gql`
  query Events($id: String!) {
    eventList(id: $id, preview: ${isPreview}) {
      title
      eventsCollection(limit: 10) {
        items {
          ...EventInfo
        }
      }
    }
  }
  ${FRAGMENT_EVENT}
  ${FRAGMENT_PERSON_INFO}
`
